import { render, staticRenderFns } from "./HeroEbook.vue?vue&type=template&id=2f142210"
import script from "./HeroEbook.vue?vue&type=script&lang=js"
export * from "./HeroEbook.vue?vue&type=script&lang=js"
import style0 from "./HeroEbook.vue?vue&type=style&index=0&id=2f142210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports